import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import type SemeiaSessionService from 'parog-web/services/session';
import fuiDropdown from 'wise-fui-modules/modifiers/fui-dropdown';

interface Signature {
  Args: {
    onValueUpdated: (event: Event) => Promise<void>;
    inputValue?: string;
    currentOperator: string;
    propertyName: string;
    onOperatorUpdated: (value: string) => void;
  };
}

export default class BioExamResultsInputWithOperator extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  get isDisabled() {
    if (!this.session.medic) return true;

    return !this.session.medic.isSuperUser;
  }

  onChange = value => {
    let cleanedValue;
    switch (value) {
      case '&lt;':
        cleanedValue = 'lower-than';
        break;
      case '&gt;':
        cleanedValue = 'greater-than';
        break;
      default:
        cleanedValue = 'equal-to';
        break;
    }

    this.args.onOperatorUpdated(cleanedValue);
  };

  <template>
    <div class='ui left labeled input' data-test-input-div={{@propertyName}}>
      <div
        class='ui dropdown label w-[3em] {{if this.isDisabled "disabled"}}'
        {{fuiDropdown onChange=this.onChange}}
        data-test-operator-dropdown
      >
        <div class='text'>{{t (concat 'operator.' @currentOperator)}}</div>
        <div class='menu'>
          <div class='item' data-test-value='eq'>{{t 'operator.equal-to'}}</div>
          <div class='item' data-test-value='lt'>{{t
              'operator.lower-than'
            }}</div>
          <div class='item' data-test-value='gt'>{{t
              'operator.greater-than'
            }}</div>
        </div>
      </div>

      <input
        aria-label='Saisir la valeur'
        type='text'
        class='!w-[calc(100%_-_3em)]'
        disabled={{this.isDisabled}}
        value={{if @inputValue @inputValue}}
        {{on 'focusout' @onValueUpdated}}
        data-test-input={{@propertyName}}
      />
    </div>
  </template>
}
